import React, { FC } from "react"

import { InputNumber } from "antd"

const NumberInput: FC<any> = (props) => {
  return <InputNumber style={{ width: "100%", ...props.style }} {...props} />
}

export default NumberInput
